import BlockPlacementI18nKeys from "./BlockPlacement/BlockPlacement.i18n";
import ButtonGroupAdapterKeys from "./ButtonGroupAdapter/ButtonGroupAdapter.i18n";
import FeatureItemI18nKeys from "./FeatureItem/FeatureItem.i18n";
import CarouselPlacementI18nKeys from "./ListPlacements/CarouselPlacement.i18n";
import ErrorPlacementI18nKeys from "./PlacementFactory/ErrorPlacement/ErrorPlacement.i18n";
import RotatingBannerPanelI18nKeys from "./RotatingBannerPanel/RotatingBannerPanel.i18n";
import RotatingBannerPlacementKeys from "./RotatingBannerPlacement/RotatingBannerPlacement.i18n";

export default {
  ...BlockPlacementI18nKeys,
  ...ButtonGroupAdapterKeys,
  ...CarouselPlacementI18nKeys,
  ...ErrorPlacementI18nKeys,
  ...FeatureItemI18nKeys,
  ...RotatingBannerPanelI18nKeys,
  ...RotatingBannerPlacementKeys,
};
